import styled, { keyframes } from 'styled-components';
import scaleSize from '../../utils/scale-size';
import LoaderImg from '../../assets/img/loader-yellow.png';

const loaderAnimation = keyframes`
  0% {background-position-x: 0;}
  25% {background-position-x: -${scaleSize(140)}px;}
  50% {background-position-x: -${scaleSize(280)}px;}
  75% {background-position-x: -${scaleSize(420)}px;}
  100% {background-position-x: -0px;}
`;

export const LoaderWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme, cleanBackground, isNetworkLoader }) => {
    if (cleanBackground) return 'none';
    if (isNetworkLoader) return theme.backgroundNetworkLoaderColor;

    return theme.backgroundLoaderColor;
  }};
  z-index: 101;
`;

export const Loader = styled.div`
  width: ${scaleSize(140)}px;
  height: ${scaleSize(140)}px;
  transform: translate(-50%, -50%);
  transition: none;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 101;
  background: url(${LoaderImg}) no-repeat;
  background-size: cover;
  animation-timing-function: step-end;
  animation-name: ${loaderAnimation};
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;
`;

export const StyledTextStatus = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding-top: ${scaleSize(200)}px;
  width: 100%;
  height: ${scaleSize(30)}px;
  font-size: ${scaleSize(30)}px;
  line-height: ${scaleSize(1.5, false)};
  letter-spacing: -0.33px;
  text-align: center;
`;
